import styled from "styled-components";
import { Spacing } from "components/designV2/constants";
import { mediaMax } from "components/designV2/breakpoints";

export const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.lg}px;
  padding: 0 ${Spacing.lg}px ${Spacing.lg}px;

  ${mediaMax.tablet} {
    padding: 0 ${Spacing.sm}px ${Spacing.lg}px;
  }

  ${mediaMax.mobile} {
    padding: 0 0 ${Spacing.lg}px;
  }
`;

export const PageHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${Spacing.md}px;
  flex-wrap: wrap;
`;
